import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

interface ISearchKey {
  q?: string;
}

export const useQueryState = <T>() => {
  const [queryParams, setQueryParams] = useSearchParams();

  const query: Readonly<T & ISearchKey> = useMemo(
    () => paramsToObject(queryParams.entries()),
    [queryParams]
  );

  const setQuery = (values: T, options?: { reset?: boolean }) => {
    const QObject = (
      options?.reset ? values : { ...query, ...values }
    ) as Record<string, string>;

    const q = new URLSearchParams(QObject);

    setQueryParams(q, { replace: true });
  };

  return { query, setQuery };
};

function paramsToObject(entries: IterableIterator<[string, string]>) {
  try {
    const result: any = {};
    for (const [key, value] of entries) {
      // each 'entry' is a [key, value] tuple
      result[key] = value;
    }
    return result;
  } catch (error) {}
}
